'use strict'

const { combineSubscribers } = require('redux-serial-effects')

const dynamicPages = require('./subscriber')

module.exports = () => combineSubscribers({ dynamicPages: dynamicPages() })



// WEBPACK FOOTER //
// ./dynamic-pages/rootSubscriber.js